import { __extends } from "tslib";
/**
 * Created by Kamil.Adamuszek on 2016-03-22.
 */
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import template from '../template/anchor-scroll.hbs';
import template2 from '../template/anchor-scroll-2.hbs';
import logger from '@main/externals/bss-package-logger/js/logger';
/**
 * BSSAnchorScrollComponent class
 */
var templateObject = {
    defaultTemplate: template2,
    templateWithBefore: template,
};
var baseConfig = {
    buttonFadeOut: 1500,
    scrollTopDuration: 1000,
    scrollTopDelay: 100,
    btnAnimate: 'true',
};
var BSSAnchorScrollComponent = /** @class */ (function (_super) {
    __extends(BSSAnchorScrollComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     * @listens {bss-entity-created-$ENTITY-INSTANCE-ID}
     */
    function BSSAnchorScrollComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = this;
        /**
         * Set default visibility depending on resolution,
         * the component will be visible on mobile devices only if visibilityBreakpoints does not setoverriden in UI description
         */
        config.visibilityBreakpoints = config.visibilityBreakpoints || ['xs'];
        _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        _this._componentVersion = '@@name ver. @@version';
        logger.info('AnchorScrollComponent: ' +
            config.componentType +
            ' => constructor : componentId: ' +
            config.componentId +
            ' | Params: ', _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, logger);
        _this._eventManager.subscribe('bss-entity-created-' + _this._config.entityInstanceId, _this._initAnchorScroll.bind(_this), _this.subscriberPrefix + _this._config.componentId);
        _this._eventManager.subscribe('bss-show-entity-overlay-' + _this._config.entityInstanceId, _this._onShowOverlay.bind(_this), 'Entity-' + _this._config.entityInstanceId);
        _this._eventManager.subscribe('bss-hide-entity-overlay-' + _this._config.entityInstanceId, _this._onHideOverlay.bind(_this), 'Entity-' + _this._config.entityInstanceId);
        return _this;
    }
    /**
     * @desc on show overlay
     * @private
     */
    BSSAnchorScrollComponent.prototype._onShowOverlay = function () {
        if (this._isInPopup && this._needBtnIEAdjustForBc) {
            this._componentTemplate
                .closest('.bss-toyota-dk_bc-base')
                .removeClass('bss-switch-position');
            this._componentTemplate
                .closest('.bss-entity-container')
                .removeClass('bss-switch-position');
        }
    };
    /**
     * @desc on hide overlay
     * @private
     */
    BSSAnchorScrollComponent.prototype._onHideOverlay = function () {
        if (this._isInPopup && this._needBtnIEAdjustForBc) {
            this._componentTemplate
                .closest('.bss-toyota-dk_bc-base')
                .addClass('bss-switch-position');
            this._componentTemplate
                .closest('.bss-entity-container')
                .addClass('bss-switch-position');
        }
    };
    /**
     * @desc returns object with outside containers configuration
     * @private
     */
    BSSAnchorScrollComponent.prototype._defineOutsideContainersConfig = function () {
        var popupSelector;
        var fixedOuterElementSelector;
        var contentSelector;
        if (this._config.modalContainer) {
            if (typeof this._config.modalContainer === 'object') {
                popupSelector = this._componentScope.closest(this._toolbox.$(this._config.modalContainer[0])).length
                    ? this._toolbox.$(this._config.modalContainer[0])
                    : this._toolbox.$(this._config.modalContainer[1]);
            }
            else {
                popupSelector = this._componentScope.closest(this._toolbox.$(this._config.modalContainer));
            }
        }
        else {
            var classNameBodyContainer = this._entityTemplate.attr('data-name-body');
            if (classNameBodyContainer) {
                popupSelector = this._componentScope.closest(this._toolbox.$(classNameBodyContainer));
            }
        }
        if (this._config.fixedOuterEl) {
            if (typeof this._config.fixedOuterEl === 'object') {
                fixedOuterElementSelector = this._componentScope.closest(this._toolbox.$(this._config.fixedOuterEl[0])).length
                    ? this._toolbox.$(this._config.fixedOuterEl[0])
                    : this._toolbox.$(this._config.fixedOuterEl[1]);
            }
            else {
                fixedOuterElementSelector = this._componentScope.closest(this._toolbox.$(this._config.fixedOuterEl));
            }
        }
        else {
            var classNameFixedToContainer = this._entityTemplate.attr('data-name-header');
            if (classNameFixedToContainer) {
                fixedOuterElementSelector = this._componentScope.closest(this._toolbox.$(classNameFixedToContainer));
            }
        }
        var classNameContentContainer = this._entityTemplate.attr('data-name-content');
        if (classNameContentContainer) {
            contentSelector = this._componentScope.closest(this._toolbox.$(classNameContentContainer));
        }
        else {
            contentSelector = this._componentScope.closest('modal-content');
        }
        return {
            popupSelector: popupSelector,
            fixedOuterElementSelector: fixedOuterElementSelector,
            contentSelector: contentSelector,
        };
    };
    /**
     * @desc initialize anchor scroll component
     * @listens {bss-entity-update-$ENTITY-INSTANCE-ID}
     * @listens {bss-tab-change-$ENTITY-INSTANCE-ID}
     * @listens {bss-start-scroll-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-stop-scroll-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-start-resize-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-stop-resize-for-$ENTITY-INSTANCE-ID}
     * @private method
     */
    BSSAnchorScrollComponent.prototype._initAnchorScroll = function () {
        logger.info('AnchorScrollComponent ' +
            this._config.componentId +
            ' => function : _initAnchorScroll');
        /**
         * @type {object}
         * @private
         * @desc returns object with outside containers configuration
         */
        this._outsideContainersConfig = this._defineOutsideContainersConfig();
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc target certain container
         */
        this._bodyInjection = this._toolbox.$('.bss-appended-to-body');
        /**
         * @type {boolean}
         * @private
         * @desc result of _bodyInjection presence
         */
        this._injectionResult = this._bodyInjection.length === 1 ? true : false;
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc anchor-scroll button selector
         */
        this._btn = this._toolbox.$('#' + this._config.componentId + '_btn');
        if (this._injectionResult) {
            this._btn.hide();
            return;
        }
        if (!this._isInitialised) {
            /**
             * @type {boolean}
             * @private
             * @desc flag for anchol scroll initialization status
             */
            this._isInitialised = true;
            /**
             * @type {boolean}
             * @private
             * @desc describe that simulator is in popup
             */
            this._isInPopup = this._entityTemplate.attr('is-popup')
                ? !!this._entityTemplate.attr('is-popup')
                : typeof this._config.isInPopup === 'undefined'
                    ? false
                    : this._config.isInPopup;
            /**
             * @type {jQuery|HTMLElement}
             * @private
             * @desc global window element
             */
            this._globalWindow = this._config.isInPopup
                ? this._toolbox.$(this._outsideContainersConfig.popupSelector)
                : this._window;
            /**
             * @type {jQuery|HTMLElement}
             * @private
             * @desc global html, body element
             */
            this._globalHtmlBody = this._config.isInPopup
                ? this._toolbox.$(this._outsideContainersConfig.popupSelector)
                : this._htmlBody;
            /**
             * @type {jQuery|HTMLElement}
             * @private
             * @desc depends top selector container
             */
            this._dependsTopSelector = this._config.dependsTopSelector
                ? this._entityTemplate.find(this._config.dependsTopSelector)
                : this._entityTemplate;
            /**
             * @type {jQuery|HTMLElement}
             * @private
             * @desc depends bottom selector container
             */
            this._dependsBottomSelector = this._config.dependsBottomSelector
                ? this._entityTemplate.find(this._config.dependsBottomSelector)
                : this._entityTemplate;
            /**
             * @type {jQuery|HTMLElement}
             * @private
             * @desc anchor scroll container that scroll to
             */
            this._$target = this._toolbox.$(this._config.scrollTo); // whatever element you want to check
            if (!this._$target.length) {
                this._$target = this._entityTemplate;
            }
            if (this._$target.length > 0) {
                /**
                 * @type {jQuery|HTMLElement}
                 * @private
                 * @desc anchor scroll container that fixed to
                 */
                this._fixedToContainer = this._toolbox.$(this._config.fixedTo);
                if (!this._fixedToContainer.length) {
                    //if there is no custom container, anchor scroll should be fixed to entity.
                    this._fixedToContainer = this._entityTemplate;
                }
                /**
                 * @type {jQuery|HTMLElement}
                 * @private
                 * @desc anchor scroll container on top
                 */
                this._dependsTopSelector = this._config.dependsTopSelector
                    ? this._entityTemplate.find(this._config.dependsTopSelector)
                    : this._entityTemplate;
                /**
                 * @type {jQuery|HTMLElement}
                 * @private
                 * @desc anchor scroll container on bottom
                 */
                this._dependsBottomSelector = this._config.dependsBottomSelector
                    ? this._entityTemplate.find(this._config.dependsBottomSelector)
                    : this._entityTemplate;
                /**
                 * @type {Number}
                 * @private
                 * @desc height of window
                 */
                this._globalWindowHeight = this._globalWindow.height();
                /**
                 * @type {Number}
                 * @private
                 * @desc height of depends top selector
                 */
                this._dependsTopSelectorHeight = this._dependsTopSelector.outerHeight();
                /**
                 * @type {Number}
                 * @private
                 * @desc height of depends bottom selector
                 */
                this._dependsBottomSelectorHeight = this._config.dependsBottomSelector
                    ? this._dependsBottomSelector.outerHeight()
                    : 0;
                /**
                 * @type {Number}
                 * @private
                 * @desc height of anchor scroll container that fixed to
                 */
                this._fixedToHeight = this._fixedToContainer.outerHeight();
                /**
                 * @type {Object}
                 * @private
                 * @desc outer element selectror
                 */
                this._fixedOuterEl = this._toolbox.$(this._outsideContainersConfig.fixedOuterElementSelector);
                /**
                 * @type {Number}
                 * @private
                 * @desc how much btn is moved from the right of popup/window side (in percentage)
                 */
                this._btnPercentageMove = 7;
                this._needBtnIEAdjustForBc =
                    this._componentTemplate.hasClass('bss-anchor-scroll--adjust') &&
                        !!navigator.userAgent.match(/Trident\/7\./);
                if (this._fixedOuterEl.length) {
                    /**
                     * @type {Number}
                     * @private
                     * @desc outer container height
                     */
                    this._fixedOuterElHeight = this._fixedOuterEl.outerHeight();
                    /**
                     * @type {Number}
                     * @private
                     * @desc outer container position
                     */
                    this._fixedOuterElPosition = this._fixedOuterEl.position().top;
                }
                else {
                    this._fixedOuterEl = null;
                    this._fixedOuterElHeight = 0;
                    this._fixedOuterElPosition = 0;
                }
                this._dependsMarginTop = this._config.dependsMarginTop
                    ? this._config.dependsMarginTop
                    : 30;
                this._getCalculationData();
                this._eventManager.subscribe('bss-entity-update-' + this._config.entityInstanceId + '-offerId', this._onResize.bind(this), this.subscriberPrefix + this._config.componentId);
                this._eventManager.subscribe('bss-tab-change-' + this._config.entityInstanceId, this._onResize.bind(this), this.subscriberPrefix + this._config.componentId);
                this._btn.on('click.' + this._config.componentId, this._scrollTo.bind(this));
                this._isScrollEventOff = true;
                this._isResizeEventOff = true;
                this._bindScroll();
                this._bindResize();
                this._eventManager.subscribe('bss-start-scroll-for-' + this._config.entityInstanceId, this._bindScroll.bind(this), this.subscriberPrefix + this._config.componentId);
                this._eventManager.subscribe('bss-stop-scroll-for-' + this._config.entityInstanceId, this._unbindScroll.bind(this), this.subscriberPrefix + this._config.componentId);
                this._eventManager.subscribe('bss-start-resize-for-' + this._config.entityInstanceId, this._bindResize.bind(this), this.subscriberPrefix + this._config.componentId);
                this._eventManager.subscribe('bss-stop-resize-for-' + this._config.entityInstanceId, this._unbindResize.bind(this), this.subscriberPrefix + this._config.componentId);
            }
        }
        if (this._isInPopup && this._needBtnIEAdjustForBc) {
            this._componentTemplate
                .closest('.bss-toyota-dk_bc-base')
                .addClass('bss-switch-position');
            this._componentTemplate
                .closest('.bss-entity-container')
                .addClass('bss-switch-position');
        }
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSAnchorScrollComponent.prototype._bindScroll = function () {
        logger.info('AnchorScrollComponent ' +
            this._config.componentId +
            ' => function : _bindScroll');
        if (this._isScrollEventOff) {
            this._globalWindow.on('scroll.' + this._config.componentId, this._getCalculationData.bind(this));
            this._isScrollEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSAnchorScrollComponent.prototype._unbindScroll = function () {
        logger.info('AnchorScrollComponent ' +
            this._config.componentId +
            ' => function : _unbindScroll');
        this._globalWindow.off('scroll.' + this._config.componentId);
        this._isScrollEventOff = true;
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSAnchorScrollComponent.prototype._bindResize = function () {
        logger.info('AnchorScrollComponent ' +
            this._config.componentId +
            ' => function : _bindResize');
        if (this._isResizeEventOff) {
            this._window.on('resize.' + this._config.componentId, this._onResize.bind(this));
            this._isResizeEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSAnchorScrollComponent.prototype._unbindResize = function () {
        logger.info('AnchorScrollComponent ' +
            this._config.componentId +
            ' => function : _unbindResize');
        this._window.off('resize.' + this._config.componentId);
        this._isResizeEventOff = true;
    };
    /**
     * @desc on resize - get calculation data
     * @private
     */
    BSSAnchorScrollComponent.prototype._onResize = function () {
        logger.info('AnchorScrollComponent ' +
            this._config.componentId +
            ' => function : _onResize');
        this._globalWindowHeight = this._globalWindow.height();
        if (this._resolution.getCurrent() !== 'xs') {
            this._dependsTopSelectorHeight = this._dependsTopSelector.outerHeight();
        }
        this._dependsBottomSelectorHeight = this._config.dependsBottomSelector
            ? this._dependsBottomSelector.outerHeight()
            : 0;
        if (this._fixedOuterEl) {
            this._fixedOuterElHeight = this._fixedOuterEl.outerHeight();
            this._fixedOuterElPosition = this._fixedOuterEl.position().top;
        }
        this._getCalculationData();
    };
    /**
     * @desc get calculation data
     * @private
     */
    BSSAnchorScrollComponent.prototype._getCalculationData = function () {
        logger.info('AnchorScrollComponent ' +
            this._config.componentId +
            ' => function : _getCalculationData');
        /**
         * @type {Number}
         * @private
         * @desc scroll top of window
         */
        this._globalWindowTop = this._globalWindow.scrollTop();
        /**
         * @type {Number}
         * @private
         * @desc position top of anchor scroll container that fixed to
         */
        this._fixedToPositionTop = this._fixedToContainer.position().top;
        /**
         * @type {Number}
         * @private
         * @desc position top of anchor scroll container target
         */
        this._targetPosition = this._$target.position().top;
        if (this._isInPopup) {
            this._dependsBottomSelector = this._config.dependsBottomSelector
                ? this._entityTemplate.find(this._config.dependsBottomSelector)
                : this._entityTemplate;
            this._dependsBottomSelectorHeight = this._config.dependsBottomSelector
                ? this._dependsBottomSelector.outerHeight()
                : 0;
        }
        this._fixedToHeight = this._fixedToContainer.outerHeight();
        //set max-width of btn container to the width of popup/window
        this._btn
            .parent()
            .css('max-width', this._toolbox.$(this._outsideContainersConfig.contentSelector).width());
        this._checkDisplay();
    };
    /**
     * @desc _prepareData - merge default config with config from proxy
     * @private
     */
    BSSAnchorScrollComponent.prototype._prepareData = function () {
        logger.info('AnchorScrollComponent ' +
            this._config.componentId +
            ' => function : _prepareData');
        var _config = {};
        this._toolbox.$.extend(true, _config, baseConfig);
        this._config = this._toolbox.$.extend(true, _config, this._config);
    };
    /**
     * @desc checks whether the anchor-scroll button should be displayed
     * @private
     */
    BSSAnchorScrollComponent.prototype._checkDisplay = function () {
        logger.info('AnchorScrollComponent ' +
            this._config.componentId +
            ' => function : _checkDisplay');
        if (!JSON.parse(this._config.btnAnimate)) {
            this._btn.addClass('is-show');
            return;
        }
        var myTop;
        var containerBottom;
        var bottom;
        var windowBottom = this._globalWindowTop + this._globalWindowHeight;
        var right;
        //move btn to % of the width of popup/window
        right = parseInt((this._btnPercentageMove * this._globalWindow.width()) / 100);
        if (this._isInPopup) {
            containerBottom =
                this._fixedOuterElHeight +
                    this._fixedToHeight +
                    this._dependsBottomSelectorHeight +
                    this._dependsTopSelectorHeight;
            myTop = this._fixedOuterElHeight;
            if (this._resolution.getCurrent() === 'xs') {
                myTop += this._dependsBottomSelectorHeight;
            }
        }
        else {
            myTop = this._fixedToPositionTop - this._dependsTopSelectorHeight;
            containerBottom = this._fixedToPositionTop + this._fixedToHeight;
        }
        if ((this._globalWindowTop <= myTop &&
            this._resolution.getCurrent() !== 'xs') ||
            this._globalWindowHeight > containerBottom ||
            this._fixedOuterElHeight >= this._globalWindowTop) {
            this._btn.removeClass('is-show');
            this._btn.hide();
        }
        else if (windowBottom >= containerBottom) {
            this._btn.addClass('is-show');
            var bottomPosition = windowBottom - containerBottom - this._dependsBottomSelectorHeight;
            bottomPosition = bottomPosition > 0 ? bottomPosition : 0;
            this._btn.css({
                bottom: bottomPosition + 'px',
                right: right,
            });
            this._btn.show();
        }
        else {
            this._btn.addClass('is-show');
            if (this._dependsBottomSelectorHeight <=
                this._fixedOuterElHeight +
                    parseInt(this._$target.css('margin-top')) ||
                this._resolution.getCurrent() !== 'xs' ||
                myTop >= 0) {
                bottom = 0;
            }
            else {
                bottom = myTop - this._dependsBottomSelectorHeight;
            }
            this._btn.css({
                bottom: (bottom > 0 ? bottom : 0) + 'px',
                right: right,
            });
            this._btn.show();
        }
        if (this._isInPopup &&
            this._needBtnIEAdjustForBc &&
            this._btn.hasClass('is-show')) {
            right =
                this._toolbox.$(this._outsideContainersConfig.contentSelector).offset()
                    .left + 80;
            bottom =
                this._toolbox.$(window).height() -
                    (this._fixedOuterEl.offset().top +
                        this._toolbox
                            .$(this._outsideContainersConfig.contentSelector)
                            .height());
            this._btn.css({
                bottom: (bottom > 0 ? bottom : 0) + 70 + 'px',
                right: right,
            });
        }
    };
    /**
     *
     * @private
     * @desc scrolling to element provided in configuration
     * @param {Object} el - event
     * @emits {bss-entity-scrollTop-$ENTITY-INSTANCE-ID}
     */
    BSSAnchorScrollComponent.prototype._scrollTo = function (el) {
        logger.info('AnchorScrollComponent ' +
            this._config.componentId +
            ' => function : _scrollTo | Params: ', el);
        el.preventDefault();
        var scrollTop = this._isInPopup
            ? {
                scrollTop: this._targetPosition -
                    this._fixedOuterElPosition -
                    this._fixedOuterElHeight -
                    this._dependsTopSelectorHeight,
            }
            : {
                scrollTop: this._targetPosition -
                    this._fixedOuterElPosition -
                    this._fixedOuterElHeight,
            };
        if (JSON.parse(this._config.btnAnimate)) {
            this._btn.fadeOut(parseFloat(this._config.buttonFadeOut));
        }
        this._globalHtmlBody
            .delay(parseFloat(this._config.scrollTopDelay))
            .animate(scrollTop, parseFloat(this._config.scrollTopDuration), this._checkDisplay.bind(this));
        this._eventManager.publish('bss-entity-scrollTop-' + this._config.entityInstanceId, 'bss-anchor-scroll-component', scrollTop, true);
    };
    return BSSAnchorScrollComponent;
}(BSSAbstractComponent));
export default BSSAnchorScrollComponent;
